import React from 'react';
import {useDispatch} from 'react-redux';
import {map, filter} from 'lodash';
import {Card, Loader, Table, Dropdown, Checkbox} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {pageSizes} from '../../../common/constants/lists';
import TablePaginator from '../../../common/components/tablePaginator';
import TableDetailBody from './tableBody';

const {
  changeDevicesOrdersPage,
  resizeDevicesOrdersPage,
  changeChassisMarked,
  changeOrdersMarked,
} = Actions;

const hideClass = (filteredList) => {
  return filteredList.some((x) => x.anticipatedInvoice === 'S') ? 'hide' : '';
};

const Detail = ({type, devicesOrders, filtersState, orderStatusList, generateOrders}) => {
  const dispatch = useDispatch();

  const {
    loading,
    creating,
    downloading,
    pageSize,
    page,
    list,
    chassisMarked,
    ordersMarked,
    filteredList,
  } = devicesOrders;

  const onOrderHeaderCheckboxChange = (event, value) => {
    if (value.checked) {
      dispatch(changeChassisMarked(map(list, 'chassis')));
      const notNullOrders = filter(list, (elem) => elem.order !== null);
      dispatch(changeOrdersMarked(map(notNullOrders, 'order')));
    } else {
      dispatch(changeChassisMarked([]));
      dispatch(changeOrdersMarked([]));
    }
  };

  const handlePageChange = (value) => {
    dispatch(changeDevicesOrdersPage(value));
  };

  const handlePageResize = (event, data) => {
    dispatch(resizeDevicesOrdersPage(data.value));
  };

  if (loading || creating || downloading) {
    return (
      <Card raised fluid className='orders-detail'>
        <Loader active inline='centered'>
          Procesando...
        </Loader>
      </Card>
    );
  }

  return (<>
    <Card raised fluid className='orders-detail' style={{'overflow': 'auto'}}>
      <Table striped compact>
        <Table.Header className='orders-table-header'>
          <Table.Row textAlign='center'>
            {list.length !== 0 && (
              <Table.HeaderCell textAlign='center'>
                <Checkbox
                  className={hideClass(filteredList)}
                  onChange={onOrderHeaderCheckboxChange}
                  disabled={loading}
                />
              </Table.HeaderCell>
            )}
            <Table.HeaderCell>Concesionario</Table.HeaderCell>
            <Table.HeaderCell>Agencia</Table.HeaderCell>
            <Table.HeaderCell>Ubicación</Table.HeaderCell>
            <Table.HeaderCell>Parking</Table.HeaderCell>
            <Table.HeaderCell>Descripción</Table.HeaderCell>
            <Table.HeaderCell>Chasis</Table.HeaderCell>
            <Table.HeaderCell>Color</Table.HeaderCell>
            <Table.HeaderCell>Fecha MOV</Table.HeaderCell>
            <Table.HeaderCell>Fecha Dispositivo</Table.HeaderCell>
            <Table.HeaderCell>Tipo Dispositivo</Table.HeaderCell>
            <Table.HeaderCell>Tipo Facturación</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Nro. Orden</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Instalado</Table.HeaderCell>
            <Table.HeaderCell>Estado Orden</Table.HeaderCell>
            <Table.HeaderCell>Fecha Instalación</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <TableDetailBody
          type={type}
          chassisMarked={chassisMarked}
          ordersMarked={ordersMarked}
          ordersFiltered={filteredList}
          orderStatusList={orderStatusList}
          filtersState={filtersState}
        />
      </Table>
    </Card>
    {list.length > pageSize && (
      <Table>
        <Table.Footer>
          <Table.Row textAlign='center'>
            <Table.Cell colSpan='100%'>
              <div className='table-pagination'>
                <span className='page-sizer'>
                  <strong>Items por página</strong>
                  <Dropdown selection upward compact value={pageSize}
                    options={pageSizes} onChange={handlePageResize}
                  />
                </span>
                <TablePaginator
                  itemsCount={list.length}
                  itemsPerPage={pageSize}
                  selectedPage={page}
                  onOptionClick={handlePageChange}
                />
              </div>
            </Table.Cell>
          </Table.Row>
        </Table.Footer>
      </Table>
    )}
  </>);
};

export default Detail;
